export default __webpack_public_path__ + "assets/tilemaps/cave_1_room_3.json";